import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';

import {
  handleLastLoginDetailsSuccess,
  handleLastLoginDetailsError,
  handleLastLoginAlertSuccess,
  handleLastLoginAlertError,
} from '../actions/LastLoginActionCreator';
import UserManagementStore from '../stores/UserManagementStore';

const getDetailsEndpoint =
  '/ibapi/v2/banks/{bank-id}/lastlogin/lastlogindate/{customerId}';

const actionHandlers = {
  details: {
    success: handleLastLoginDetailsSuccess,
    error: handleLastLoginDetailsError,
  },
  alert: {
    success: handleLastLoginAlertSuccess,
    error: handleLastLoginAlertError,
  },
};

export const requestLastLoginDetails = ({ isAlert } = { isAlert: false }) => {
  const actionCallback = isAlert
    ? actionHandlers.alert
    : actionHandlers.details;

  const user = UserManagementStore.getCADetails();
  const customerId = user?.customers?.[0].customer_id;
  if (!customerId) {
    return actionCallback.error();
  }

  const url = `${envConfig.apiBaseUrlPAAS}${getDetailsEndpoint}`.replace(
    '{customerId}',
    customerId
  );
  ApiUtils.makeAjaxCall(
    {
      apiVersion: config.apiVersions.lastLoginService,
      method: 'GET',
      url,
      addAuthToken: true,
      doNotTrackCallProgress: true,
    },
    (body) => {
      actionCallback.success(body);
    },
    (error) => {
      actionCallback.error(error);
    }
  );
};
